import { Injectable } from '@angular/core';

/** Service used by {@link ApMatchFirstnamesValidator}.*/
@Injectable({
    providedIn: 'root'
})
export class ApMatchNamesService {
    /** Split string value into an array of substrings and convert them to uppercase letters */
    public splitInitialsAndFirstNames(stringValue: string): string[] {
        return stringValue.toUpperCase().replace(/[.]$/, '').split(/[ .]+/);
    }

    /** check if the initials match the firstletters of the first names */
    public isValidFirstNamesAndInitials(modelValues: any, attrValues: any): boolean {
        let valid = true;
        modelValues.forEach((item: string, index: number) => {
            if (item.charAt(0) !== attrValues[index].charAt(0)) {
                valid = false;
            }
        });
        return valid;
    }

    /** check if initials length match firstnames length */
    public isValidLength(modelValues: any, attrValues: any): boolean {
        return modelValues.length === attrValues.length;
    }
}
